export { DataReducer } from './DataReducer';
export { UserReducer }  from './UserReducer';
export { OptionsReducer }  from './OptionsReducer';



// WEBPACK FOOTER //
// ./src/reducers/index.js